import { IconProps } from ".";

export const FilterIcon2: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 4.79167C2.5 3.52601 3.52601 2.5 4.79167 2.5H15.2083C16.474 2.5 17.5 3.52601 17.5 4.79167V5.97631C17.5 6.5841 17.2586 7.16699 16.8288 7.59676L12.8051 11.6205C12.6097 11.8158 12.5 12.0808 12.5 12.357V16.6667C12.5 16.9474 12.3128 17.1937 12.0423 17.2689L8.29228 18.3105C8.10409 18.3628 7.90229 18.3241 7.7468 18.2059C7.5913 18.0877 7.5 17.9036 7.5 17.7083V12.357C7.5 12.0808 7.39025 11.8158 7.1949 11.6205L3.17121 7.59676C2.74144 7.16699 2.5 6.5841 2.5 5.97631V4.79167ZM4.79167 3.75C4.21637 3.75 3.75 4.21637 3.75 4.79167V5.97631C3.75 6.25258 3.85975 6.51753 4.0551 6.71288L8.07879 10.7366C8.50856 11.1663 8.75 11.7492 8.75 12.357V16.8861L11.25 16.1916V12.357C11.25 11.7492 11.4914 11.1663 11.9212 10.7366L15.9449 6.71288C16.1403 6.51753 16.25 6.25258 16.25 5.97631V4.79167C16.25 4.21637 15.7836 3.75 15.2083 3.75H4.79167Z"
        fill="currentColor"
      />
    </svg>
  );
};
